import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonContent, NavController, NavParams, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'download-apps',
  templateUrl: './download-apps.component.html',
  styleUrls: ['./download-apps.component.scss'],
})
export class DownloadAppsComponent implements OnInit {
    @ViewChild(IonContent, { static: false }) content: IonContent;

  public loginUrl;
  public error: any = null;
  public resetPasswordForm: FormGroup;

  public customer: CustomerModel;
  public customerid:any;
  isAuthenticated: boolean;
  googleDownloadLink: any;
  appleDownloadLink: any;
  public isIOSWeb: boolean;
  public isAndroidWeb: boolean;
  public isDesktopWeb: boolean;



  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public userSession: UserSessionService,
      public successMessageProvider: SuccessMessageService,
      public config: ConfigService,
      public utils: UtilsService,
      public navigator: Navigator,
      public platform: Platform,
      public authenticationService: AuthenticationService,
      private appLinks: AppLinksService
  ) {
    this.verifyAuth();
  }

  ngOnInit() {
    this.googleDownloadLink = this.config.getConfig().APP_UPDATE_URL_ANDROID ? this.config.getConfig().APP_UPDATE_URL_ANDROID : 'https://play.google.com/store/apps/details?id=com.ati.b2bsocial.stardust';
    this.appleDownloadLink = this.config.getConfig().APP_UPDATE_URL_IOS ? this.config.getConfig().APP_UPDATE_URL_IOS : 'https://apps.apple.com/us/app/stardust-casino-slots-vegas/id1505601180';
    this.isIOSWeb = ((this.platform.is('ios')) && (this.platform.is('mobile') || this.platform.is('mobileweb')));
    this.isAndroidWeb = ((this.platform.is('android')) && (this.platform.is('mobile') || this.platform.is('mobileweb')));
    this.isDesktopWeb = this.platform.is('desktop');
  }


  private verifyAuth(): any {
    this.userSession.isAuthenticated().then((auth) => {
      if (auth) return this.isAuthenticated = true;
      return this.isAuthenticated = false;
    })
  }


  openLink(context){
    if(context === 'apple'){
      this.appLinks.openExternalPage(this.appleDownloadLink);
    }

    if(context === 'google'){
      this.appLinks.openExternalPage(this.googleDownloadLink);
    }
  }


 
}
